<template>
  <div
    class="shadow p-2 mt-2"
    style="border: 1px solid lightgrey;"
  >
    <b-row>
      <b-col cols="12" md="3">
        <dl>
          <dt>Status</dt>
          <dd>
            <b-badge
              pill
              :variant="`light-${resolveStatusVariant(importReport.status)}`"
              class="text-capitalize"
            >
              {{ startCase(importReport.status) }}
            </b-badge>
          </dd>
        </dl>
      </b-col>
      <b-col cols="12" md="3">
        <dl class="font-weight-bolder text-primary">
          <dt class="font-weight-bolder">Total Records</dt>
          <dd class="font-weight-bolder">
            {{
              importReport.total_records
            }}
          </dd>
        </dl>
      </b-col>
      <b-col cols="12" md="3">
        <dl class="text-success">
          <dt>Successful Imports</dt>
          <dd>
            {{
              importReport.success_records
            }}
          </dd>
        </dl>
      </b-col>
      <b-col cols="12" md="3">
        <dl class="text-danger">
          <dt>Failed Imports</dt>
          <dd>
            {{
              importReport.failed_records
            }}
          </dd>
        </dl>
      </b-col>
      <b-col cols="12" md="3">
        <dl>
          <dt>Report Type</dt>
          <dd>
            {{ importReport.report_type }}
          </dd>
        </dl>
      </b-col>
      <b-col cols="12" md="3">
        <dl>
          <dt>Uploaded On</dt>
          <dd class="font-weight-bold">
            {{ formatDate(importReport.created, "do MMMM, yyyy") }}
          </dd>
        </dl>
      </b-col>
      <b-col cols="12" md="3">
        <dl>
          <dt>Last Update</dt>
          <dd class="font-weight-bold">
            {{ formatDate(importReport.modified, "do MMMM, yyyy") }}
          </dd>
        </dl>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BAlert,
  BOverlay,
  BButton,
  BCard,
  BCol,
  BRow,
  BBadge,
  BForm,
  BModal,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BFormTextarea,
  BDropdown,
  BDropdownItem,
  BFormCheckboxGroup,
} from "bootstrap-vue";
import { startCase } from "lodash";

export default {
  name: "ImportReport",
  components: {
    BBadge,
    BAlert,
    BOverlay,
    BButton,
    BCard,
    BCol,
    BRow,
    BForm,
    BModal,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BFormTextarea,
    BDropdown,
    BDropdownItem,
    BFormCheckboxGroup,
  },
  props: {
    importReport: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  computed: {
    appraisalWindow() {
      return this.getValueFromSource(this.appraisal, "appraisal_window");
    },
    assessmentPeriod() {
      let { start_date = "", end_date = "" } = this.appraisalWindow.period;

      if (start_date) {
        start_date = this.formatDate(start_date, "do MMM yyyy");
      }
      if (end_date) {
        end_date = this.formatDate(end_date, "do MMM yyyy");
      }
      return `${start_date} - ${end_date}`;
    },
    deadlineForSubmission() {
      return this.getValueFromSource(
        this.appraisal,
        "appraisal_window.submissions.end_date"
      );
    },
    subjectOfAppraisal() {
      return this.getValueFromSource(this.appraisal, "user");
    },
    supervisor() {
      return this.getValueFromSource(this.appraisal, "user.supervisor.full_name");
    }
  },
  methods: {
    startCase
  }
};
</script>

<style lang="scss" scoped></style>
